import { DotLegalSelect, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../localization/useTranslation.ts";
import { useSelectableDeletionPeriodsQuery } from "../../common/hooks/useSelectableItemQueries.ts";

export interface DeletionPeriodFieldProps {
    deletionPeriodId: string | null | undefined;
    deletionPeriodReason: string | undefined;
    onDeletionPeriodChange: (deletionPeriodId: string | null) => void;
    onDeletionPeriodReasonChange: (reason: string | undefined) => void;
    readOnly?: boolean;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
}

function DeletionPeriodField(props: DeletionPeriodFieldProps) {
    const { translateString } = useTranslation();
    const deletionPeriodsQuery = useSelectableDeletionPeriodsQuery(!props.isPreview);

    const showReason = props.isPreview || !!props.deletionPeriodId;

    return (
        <>
            <DotLegalSelect
                label={translateString("deletionPeriod")}
                placeholder={translateString("deletionPeriod")}
                selectedItem={props.deletionPeriodId ?? null}
                options={deletionPeriodsQuery.data}
                isLoading={deletionPeriodsQuery.isLoading && !props.readOnly}
                onChange={props.readOnly ? () => {} : (value) => props.onDeletionPeriodChange(value)}
                disabled={props.disabled}
                toolTipText={translateString("systemDeletionPeriodTooltip")}
                noOptionsLabel={translateString("noOptions")}
                errorText={props.errorText}
            />
            {showReason && (
                <DotLegalTextField
                    label={translateString("deletionPeriodReason")}
                    value={props.deletionPeriodReason ?? ""}
                    debounce={!props.readOnly}
                    onChange={props.readOnly ? () => {} : (value) => props.onDeletionPeriodReasonChange(value)}
                    disabled={props.disabled}
                />
            )}
        </>
    );
}

export default DeletionPeriodField;
